export default class extends Controller {
  connect() {
    if (this.url) {
      App.Helpers.ajaxRequest({
        url: this.url,
        successHandler: this.replaceComponentWithResponse.bind(this)
      });
    }
  }

  replaceComponentWithResponse(response) {
    App.Helpers.replaceElement(this.element, response);
  }

  toggle() {
    this.element.classList.toggle('expanded');

    // Remember the state of the sidebar
    if (this.element.classList.contains('expanded')) {
      $.cookie('overviews_sidebar_shown', true);
    } else {
      $.removeCookie('overviews_sidebar_shown');
    }
  }


  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url');
  }

};



// WEBPACK FOOTER //
// ./app/components/overviews/assets/javascript/overviews-sidebar-controller.js